import React from 'react';

// @material-ui/core components
import Grid from '@material-ui/core/Grid';

// core components
import ListBookings from './components/listBookings';

function RequestAll() {
  return (
    <Grid container spacing={0}>
      <Grid item md={12}>
        <ListBookings />
      </Grid>
    </Grid>
  );
}

export default RequestAll;
